import create from './create-type';

const type = 'template';

export const FETCH_TEMPLATES_LIST = create(type, 'FETCH_TEMPLATES_LIST');
export const FETCH_TEMPLATES_LIST_SUCCESS = create(type, 'FETCH_TEMPLATES_LIST_SUCCESS');
export const FETCH_TEMPLATES_LIST_FAILURE = create(type, 'FETCH_TEMPLATES_LIST_FAILURE');

export const CREATE_TEMPLATE = create(type, 'CREATE_TEMPLATE');
export const CREATE_TEMPLATE_SUCCESS = create(type, 'CREATE_TEMPLATE_SUCCESS');
export const CREATE_TEMPLATE_FAILURE = create(type, 'CREATE_TEMPLATE_FAILURE');

export const UPDATE_TEMPLATE = create(type, 'UPDATE_TEMPLATE');
export const UPDATE_TEMPLATE_SUCCESS = create(type, 'UPDATE_TEMPLATE_SUCCESS');
export const UPDATE_TEMPLATE_FAILURE = create(type, 'UPDATE_TEMPLATE_FAILURE');

export const DELETE_TEMPLATE = create(type, 'DELETE_TEMPLATE');
export const DELETE_TEMPLATE_SUCCESS = create(type, 'DELETE_TEMPLATE_SUCCESS');
export const DELETE_TEMPLATE_FAILURE = create(type, 'DELETE_TEMPLATE_FAILURE');

export const FETCH_TEMPLATES_VARIABLES = create(type, 'FETCH_TEMPLATES_VARIABLES');
export const FETCH_TEMPLATES_VARIABLES_SUCCESS = create(type, 'FETCH_TEMPLATES_VARIABLES_SUCCESS');

// 
export const SET_SELECTED_TEMPLATE = create(type, 'SET_SELECTED_TEMPLATE');
export const CLEAR_SELECTED_TEMPLATE = create(type, 'CLEAR_SELECTED_TEMPLATE');

export const RESET_FORM = create(type, 'RESET_FORM');
